<template>
  <v-data-table
    :loading="isLoading"
    :headers="headers"
    :items="items"
    :mobile-breakpoint="0"
    :items-per-page="15"
    :disable-sort="$vuetify.breakpoint.smAndDown"
    :options.sync="options"
    :footer-props="footerProps"
    @click:row="editApplication"
  >
    <template v-slot:item.created_at="{ item }">
      {{ item.created_at | date('YYYY/MM/DD') }}
    </template>
    <template v-slot:item.type="{ item }">
      {{ typesMapping[item.type] }}
    </template>
    <template v-slot:item.status="{ item }">
      <status-chip :status="item.status"></status-chip>
    </template>
  </v-data-table>
</template>

<script>
import { date } from '../libs/filters';
import { pagination } from '../libs/mixins';
import { mapActions, mapState } from 'vuex';
import StatusChip from '../components/StatusChip';

export default {
  mixins: [
    pagination,
  ],

  filters: {
    date,
  },

  components: {
    StatusChip,
  },

  data() {
    return {
      isLoading: false,
      typesMapping: {
        apply: this.$t('一般門號'),
        upgrade: this.$t('升級'),
        change: this.$t('換補卡'),
      },
    };
  },

  computed: {
    headers() {
      return [
        { text: this.$t("日期"), value: 'created_at', width: '20%' },
        { text: this.$t("狀態"), value: 'status' },
        { text: this.$t("門號類型"), value: 'type' },
        { text: this.$t("門號"), value: 'sim.phone' },
        { text: this.$t("證號"), value: 'identity_no', width: '30%' },
      ];
    },

    ...mapState('applications', {
      items: 'all'
    }),
  },

   async mounted() {
    this.isLoading = true;
    await this.fetchAll();
    this.isLoading = false;
  },

  methods: {
    editApplication(item) {
      this.$router.push({
        name: 'apply',
        params: {
          id: item.id
        }
      });
    },

    ...mapActions('applications', {
      queryResults: 'get',
    })
  }
}
</script>
